const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product_card',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  initGrid();
});


const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=wishlist-no-layout`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      button.classList.add('adding-wishlist');
      setTimeout(() => {
        button.classList.remove('adding-wishlist'); 
      }, 1000);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);
  updateWishlistCount();
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const updateWishlistCount = () => {
  const wishlist = getWishlist();

  const wishlistCountElements = document.querySelectorAll('[data-header-wishlist-count], [data-account-wishlist-count]');
  wishlistCountElements.forEach((element) => {
    element.setAttribute('data-header-wishlist-count', wishlist.length);
    element.textContent = wishlist.length;
  });

  const wishlistTextElement = document.querySelector('.wishlist-text');
  if (wishlistTextElement) {
    wishlistTextElement.style.display = wishlist.length === 0 ? 'block' : 'none';
  }
};

function wislistToaster() {
  const progressBar = document.getElementById('wishlistToastProgress');

  function showToast(event) {
    if (event.currentTarget.classList.contains('active')) { 
      return;
    }

    const toast = document.getElementById('wishlistToast');
    toast.style.display = 'block';
    progressBar.style.width = '0%';

    let progress = 0;
    const duration = 5000;

    function updateProgressBar() {
      if (progress < 100) {
        progress += (100 / duration) * 1000 / 60;
        progressBar.style.width = `${progress}%`;
        requestAnimationFrame(updateProgressBar);
      } else {
        toast.style.display = 'none';
      }
    }
    requestAnimationFrame(updateProgressBar);
  }

  this.initToaster = function () {
    const toggleButtons = document.querySelectorAll('.btn_wishlist:not(.active)');
    toggleButtons.forEach(function (button) {
      button.addEventListener("click", showToast);
    });
  };
}
const wislist_local_toast = new wislistToaster();
wislist_local_toast.initToaster();

document.addEventListener('DOMContentLoaded', function() {
  updateWishlistCount();
});

